import React from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import IndustryHero from '../../components/industries/IndustryHero';
import IndustryContent from '../../components/industries/IndustryContent';
import IndustryCTA from '../../components/industries/IndustryCTA';

const WealthManagement = () => {
  const industryData = {
    title: 'Wealth Management',
    subtitle: 'Digital platforms for wealth advisors and investors',
    description: 'Empower wealth managers and their clients with sophisticated portfolio management tools, robo-advisory platforms, and comprehensive financial planning solutions that drive better investment outcomes.',
    challenges: [
      {
        title: 'Portfolio Management',
        description: 'Build comprehensive portfolio tracking and rebalancing tools with real-time market data and performance analytics.'
      },
      {
        title: 'Robo-Advisory',
        description: 'Develop AI-powered investment advisory platforms that provide personalized recommendations based on risk profiles and goals.'
      },
      {
        title: 'Client Portals',
        description: 'Create secure client portals where investors can view their portfolios, documents, and communicate with advisors.'
      },
      {
        title: 'Financial Planning',
        description: 'Design tools for retirement planning, tax optimization, and estate planning that help advisors serve their clients better.'
      }
    ],
    services: [
      'Portfolio Management Systems',
      'Robo-Advisory Platform Development',
      'Client Relationship Management',
      'Financial Planning Software',
      'Risk Assessment Tools',
      'Reporting and Analytics Dashboards'
    ],
    technologies: ['React', 'Python', 'Node.js', 'PostgreSQL', 'Machine Learning', 'Data Analytics', 'APIs']
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Wealth Management Technology"
        description="Digital platforms for wealth management — portfolio management, client portals, and advisory tools for asset managers and financial advisors."
        path="/industries/wealth-management"
      />
      <Header />
      <IndustryHero data={industryData} />
      <IndustryContent data={industryData} />
      <IndustryCTA industry="Wealth Management" />
      <Footer />
    </div>
  );
};

export default WealthManagement;
